import React from 'react';
import { Button, ButtonText } from '../../../core/controls/button/Button';
import Translate from '../../../core/translate/Translate';
import { translate } from '../../utils/translate/translations';
import SvgIcon from 'core/icons/SvgIcon';
import { useSearchParams } from 'react-router-dom';
import addShopperParams from '../../utils/addShopperParams';

const Inventory = ({
  modelInfo,
  postalCode,
  onEditLocation,
  inventoryResult,
}) => {
  const [searchParams] = useSearchParams();
  const { isCanada } = modelInfo;

  const editLocationMessage = `${translate(
    'summary.home.location.v3'
  )} ${postalCode}`;

  const { vsrUrl, isExactMatch, isMatch, vdpUrl } = inventoryResult ?? {};
  const hasCanadaVsrUrl = isCanada && !!vsrUrl;
  let showInventoryButton =
    hasCanadaVsrUrl || (isMatch && !isExactMatch && !!vsrUrl);
  const isFamilyFirstCA = modelInfo?.isFamilyFirstCA;
  showInventoryButton = isFamilyFirstCA ? false : showInventoryButton;

  return (
    <>
      {(hasCanadaVsrUrl || (isMatch && (vdpUrl || vsrUrl))) && !isFamilyFirstCA && (
        <div className="inventory__status">{inventoryResult.label}</div>
      )}
      <div className="inventory__change-location">
        <SvgIcon
          name="pin"
          className="inventory__change-location-pin button__icon--left"
        />
        <div className="inventory__change-location-message">
          {editLocationMessage}
        </div>
        <Button
          onClick={onEditLocation}
          className="inventory__change-location-edit stat-text-link"
          link={true}
          data-dtm="next steps:location">
          <ButtonText>
            <Translate value="edit.v3" />
          </ButtonText>
        </Button>
      </div>
      <div>
        {(showInventoryButton || isExactMatch) && !isFamilyFirstCA && (
          <div className="inventory__vehicle-search-results">
            {showInventoryButton && (
              <Button
                as="a"
                href={addShopperParams(
                  vsrUrl,
                  searchParams,
                  false,
                  true,
                  hasCanadaVsrUrl ? postalCode : null
                )}
                className="stat-button-link inventory__button"
                data-dtm="next steps"
                target="_blank">
                <ButtonText>
                  <Translate value="vehicle.all.inventory.v3" />
                </ButtonText>
              </Button>
            )}
            {isExactMatch && (
              <>
                {vdpUrl && (
                  <Button
                    as="a"
                    href={addShopperParams(
                      inventoryResult.vdpUrl,
                      searchParams
                    )}
                    className="stat-button-link inventory__button">
                    <ButtonText>
                      <Translate value="vehicle.details.v3" />
                    </ButtonText>
                  </Button>
                )}
                {vsrUrl && (
                  <Button
                    as="a"
                    href={addShopperParams(
                      vsrUrl,
                      searchParams,
                      false,
                      true,
                      hasCanadaVsrUrl ? postalCode : null
                    )}
                    className="stat-button-link inventory__button inventory__button--secondary"
                    data-dtm="next steps"
                    target="_blank">
                    <ButtonText>
                      <Translate value="vehicle.all.inventory.v3" />
                    </ButtonText>
                  </Button>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Inventory;
